import React from "react"
import { PuxInput, PuxTypography, useTranslation } from "@phonero/pux-react"
import cx from "classnames"
import classNames from "classnames"
import css from "./EmbeddedSimEmail.module.scss"

export interface IEmbeddedSimEmailProps {
  email: string
  forceRequired: boolean
  onUpdate: (email: string) => void
}

export const ValidateEmail = (email: string | undefined): Boolean => {
  if (!email) return false
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regex.test(email)
}

export const EmbeddedSimEmail = ({
  email,
  forceRequired,
  onUpdate,
}: IEmbeddedSimEmailProps) => {
  const { t } = useTranslation()
  return (
    <div className={css.container}>
      {/* <h2>{t("AddSubscriptionWizard.Step4.EmailAddress")}</h2> */}
      <div className={cx(css.containerFullWidth, css.containerMediumHeight)}>
        <PuxTypography
          variant={"label"}
          component={"label"}
          className={css.paddedTop10}
        >
          {t("AddSubscriptionWizard.Step4.Email")}*
        </PuxTypography>
        <PuxInput
          type="text"
          placeholder={t("AddSubscriptionWizard.Step4.Email")}
          value={email || ""}
          onPuxChange={({ detail }) => {
            onUpdate(detail?.value as string)
          }}
          className={classNames({
            invalid: forceRequired && !ValidateEmail(email),
          })}
          required
          maxlength={75}
        />
        <PuxTypography
          variant={"label"}
          component={"span"}
          style={{
            paddingTop: 5,
            color: "#040D2999",
          }}
        >
          {t("AddSubscriptionWizard.Step4.EmailDetails")}
        </PuxTypography>
      </div>
    </div>
  )
}
